import { render, staticRenderFns } from "./WorkTableDialog.vue?vue&type=template&id=732665a8&scoped=true"
import script from "./WorkTableDialog.vue?vue&type=script&lang=js"
export * from "./WorkTableDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkTableDialog.vue?vue&type=style&index=0&id=732665a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732665a8",
  null
  
)

export default component.exports